
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/finish",
      function () {
        return require("private-next-pages/mobiworkx/finish.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/finish"])
      });
    }
  